import { crTheme, spacing, containers } from '@comicrelief/component-library';
import styled from 'styled-components';

const Wrapper = styled.div`
  background: ${crTheme.color('blue_donate')};
  padding: ${spacing('l')} ${spacing('m')} ${spacing('m')};
  display: flex;
  flex-direction: column;
  width: 100%;
  text-align: center;

  @media ${crTheme.allBreakpoints('M')} {
    p {
      color: ${crTheme.color('black')};
    }
    background: ${crTheme.color('grey_light')};
    padding: ${spacing('lg')} ${spacing('l')};
  }
`;
const BlurbWrapper = styled.div`
  margin: 0 auto ${spacing('lg')};
  width: 100%;
`;

const Grid = styled.div`
  display: flex;
  width: 100%;
  max-width: ${containers.medium};
  margin: 0 auto;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: center;
  @media ${crTheme.allBreakpoints('L')} {
    flex-direction: row;
    gap: ${spacing('md')};
  }
`;

const Items = styled.div`
  margin: 0 0 ${spacing('md')};
  width: 100%;
  text-align: left;
  flex-grow: 0;
  flex-shrink: 1;
  flex-basis: calc(100% / 4 - ${spacing('l')});
`;

const Title = styled.div`
  margin-bottom: ${spacing('s')};
`;

export {
  Wrapper,
  BlurbWrapper,
  Title,
  Grid,
  Items
};
